import get from "lodash/get";
import { useDispatch } from "react-redux";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { CurrencyValue } from "../CurrencyValue";
import { useIsMobile } from "../../actions/ui";
import {
  setCustomValue,
  CUSTOM_VALUE_OPEN_DIGITAL_PRICES_DIALOG,
} from "../../v2_actions/custom_value";

const getGalleryPhotographPriceBox = (isMobile) => ({
  color: "#fff",
  width: "100px",
  height: isMobile ? "48px" : "40px",
  display: "flex",
  fontSize: "16px",
  alignItems: "center",
  fontWeight: "bold",
  borderRadius: "20px",
  justifyContent: "center",
  backgroundColor: "rgb(96 96 96 / 50%)",
  ...(isMobile && {
    border: "2px solid rgba(255, 255, 255, 0.25)",
  }),
});

const getExtendedGalleryPhotographPriceBox = (isMobile) => ({
  ...getGalleryPhotographPriceBox(isMobile),
  width: "130px",
  ...(isMobile && {
    width: "auto",
    height: "48px",
    padding: "0px 12px 0px 12px",
    marginTop: "20px",
    flexDirection: "column",
    justifyContent: "flex-start",
    whiteSpace: "nowrap",
  }),
});

const lowHighPricingDisplay = {
  margin: 0,
  fontSize: "14px",
  marginTop: 0,
  marginBottom: 0,
  lineHeight: 1.1,
  textAlign: "center",
  "& span": {
    fontSize: "14px",
  },
};

export default function GalleryPhotographPriceBox({
  price,
  gallery,
  showPhotographTimeTakenBox,
}) {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const galleryLowResPrice = get(gallery, ["gallery_price", "low_res_price"]);

  const openDigitalPricingDialog = () => {
    dispatch(
      setCustomValue({
        name: CUSTOM_VALUE_OPEN_DIGITAL_PRICES_DIALOG,
        value: true,
      }),
    );
  };

  const renderPriceBox = () => {
    if (galleryLowResPrice !== null && isMobile) {
      return (
        <Box
          onClick={openDigitalPricingDialog}
          sx={getExtendedGalleryPhotographPriceBox(isMobile)}
        >
          <Typography sx={{ ...lowHighPricingDisplay, fontSize: "14px", marginTop: "-7px" }}>
            <CurrencyValue
              showCents={false}
              value={galleryLowResPrice}
              country={get(gallery, ["gallery_price", "country"])}
            />
            /
            <CurrencyValue
              value={price}
              showCents={false}
              country={get(gallery, ["gallery_price", "country"])}
            />
          </Typography>
          <Typography sx={{ ...lowHighPricingDisplay, fontSize: "12px" }}>
            Low/High Res
          </Typography>
        </Box>
      );
    }

    return (
      <Box onClick={isMobile ? openDigitalPricingDialog : undefined}>
        <Typography
          sx={
            galleryLowResPrice
              ? getExtendedGalleryPhotographPriceBox(isMobile)
              : getGalleryPhotographPriceBox(isMobile)
          }
        >
          {galleryLowResPrice !== null && (
            <Stack
              direction="row"
              useFlexGap
              flexWrap="wrap"
              alignItems="center"
            >
              <Typography sx={lowHighPricingDisplay}>
                <CurrencyValue
                  showCents={false}
                  value={galleryLowResPrice}
                  country={get(gallery, ["gallery_price", "country"])}
                />
                /
                <CurrencyValue
                  value={price}
                  showCents={false}
                  country={get(gallery, ["gallery_price", "country"])}
                />
              </Typography>
              {showPhotographTimeTakenBox && (
                <Typography sx={{ ...lowHighPricingDisplay, fontSize: "12px" }}>
                  Low/High Res
                </Typography>
              )}
            </Stack>
          )}
          {galleryLowResPrice == null && (
            <Stack direction="row" alignItems="center" sx={isMobile ? { fontSize: "18px", marginTop: "-15px", marginLeft: "2px" } : {}}>
              <CurrencyValue
                value={price}
                showCents={false}
                country={get(gallery, ["gallery_price", "country"])}
              />
              {isMobile && (
                <KeyboardArrowDownIcon sx={{ color: "white", fontSize: 20, marginLeft: "4px" }} />
              )}
            </Stack>
          )}
        </Typography>
      </Box>
    );
  };

  return <Box>{renderPriceBox()}</Box>;
}
